import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import { createSignal } from "solid-js"
import { createEditorTransaction } from "solid-tiptap"
import { Mini } from "@/designSystem/components/mini/mini"
import { Tooltip } from "@/designSystem/components/tooltip"

type Props = {
  editor: Editor
}

export function LinkMenu(props: Props) {
  const attributes = createEditorTransaction(
    () => props.editor,
    editor => editor.getAttributes("link"),
  )

  const [localUrl, setLocalUrl] = createSignal(attributes().href || "")

  function setLink(url: string) {
    if (!url) {
      deleteLink()
      return
    }

    props.editor
      .chain()
      .focus()
      .extendMarkRange("link")
      .setLink({ href: url })
      .run()
  }

  function deleteLink() {
    props.editor.chain().focus().extendMarkRange("link").unsetLink().run()
  }

  function handleBlur() {
    const url = localUrl()
    setLink(url)
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault()
      const url = localUrl()
      setLink(url)
    }
  }

  return (
    <Mini.Menu>
      <Mini.Section>
        <Mini.Icon name="link" disabled />
        <Tooltip description="URL">
          <Mini.TextField
            fieldSizing="content"
            placeholder="URL"
            value={localUrl()}
            onChange={setLocalUrl}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
          />
        </Tooltip>
      </Mini.Section>
      <Mini.Section>
        <Tooltip description="Remove link" hue="rose">
          <Mini.Button onClick={deleteLink} iconName="x" hue="rose" />
        </Tooltip>
      </Mini.Section>
    </Mini.Menu>
  )
}
